import { Badge, ChakraFlex, ChakraText, EquipUITheme } from '@equip.health/ui';

const TOP_LEVEL_ID = 'sub-tab';
const { label: labelStyle } = EquipUITheme.typography;

interface SubTabProps {
  backgroundColor?: string;
  badgeValue?: number;
  color?: string;
  isSelected: boolean;
  label: string;
  onChange: (index: number) => void;
  value: number;
}

const SubTab = ({
  backgroundColor = 'neutral.background.primary',
  badgeValue = 0,
  color = 'primary.100',
  isSelected,
  label,
  onChange,
  value,
}: SubTabProps) => (
  <ChakraFlex
    {...labelStyle}
    backgroundColor={isSelected && backgroundColor}
    borderRadius="16px"
    boxShadow={isSelected && '0px 2px 4px 0px rgba(0, 0, 0, 0.08)'}
    color={isSelected ? color : 'neutral.secondary'}
    cursor="pointer"
    id={`${TOP_LEVEL_ID}`}
    onClick={() => onChange(value)}
    padding="5px 10px"
  >
    <ChakraText id={`${TOP_LEVEL_ID}__label`}>{label}</ChakraText>
    {badgeValue > 0 && (
      <Badge
        badgeColor="tertiary.marigold.base"
        fontSize="10px"
        id={`${TOP_LEVEL_ID}__badge`}
        margin="0 0 0 4px"
      >
        {badgeValue}
      </Badge>
    )}
  </ChakraFlex>
);

export default SubTab;
